import React, { Component } from 'react';
import { Command, Uploader } from 'ui/techPage/components';
import { connect } from 'react-redux';

import { getCommandList, getMerchantList, uploadMerchantList } from 'redux/app/actionCreators';

class TechPageBase extends Component {
    componentDidMount() {
        this.props.getCommandList();
    }

    uploadFile = (command) => {
        const file = document.getElementById('file');
        const formData = new FormData();
        formData.append('data', file.files[0], file.files[0].name);
        const extension = file.files[0].name.split('.').pop();
        const cmd = { ...command };
        cmd.commandParams = {};
        cmd.commandParams.format = extension.replace(/^\w/, c => c.toUpperCase());
        this.props.uploadMerchantList(formData, file.files[0].name, cmd);
    };

    render() {
        const {
            commandList: {
                isLoaded,
                data,
            },
        } = this.props;
        return (
            <div style={{ width: '100%', height: '100%' }}>
                {isLoaded && data.map(command => {
                    if (command.command === 'merchant:update') {
                        return (
                            <Uploader command={command} uploadFile={this.uploadFile} key={command.command} />
                        );
                    }
                    return (
                        <Command key={command.command} command={command} />
                    );
                })}
            </div>
        );
    }
}

export default connect(
    state => ({
        commandList: state.app.commandList,
    }),

    {
        getCommandList,
        getMerchantList,
        uploadMerchantList,
    },
)(TechPageBase);
